import { CSSProperties } from 'react';
import { minBreakpoints } from '@noths/polaris-client-ribbons-design-system';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

export interface CSSVarHeading extends CSSProperties {
  '--bgColor': string;
}

export const BannerLink = css`
  text-decoration: none;
  display: block;

  :hover {
    opacity: 0.9;
  }
`;

export const BannerImage = css`
  display: block;
  width: 100%;
  height: auto;
  margin: 30px 0 0;

  > img {
    width: 100%;
    height: auto;

    :first-child {
      display: none;
    }
    :last-child {
      display: block;
      width: 100%;
      height: auto;
    }
  }

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      margin: 0;

      > img:first-child {
        display: block;
      }
      > img:last-child {
        display: none;
      }
    `,
  )}
`;

export const BannerHeading = css`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  flex-direction: column;
  background: var(--bgColor);
  display: flex;
  justify-content: center;
  padding: 35px 10px;
  border-radius: 0 0 3px 3px;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      border-radius: 0;
      padding: 0 10px;
    `,
  )}
`;
